/* ----------------------------------------------------------------------------
( 4.354 weeks/month × 5 meetings/week × 15 minutes/meeting
× 1/60 hours/minute × 10 team members × $100 average team member rate/hour )
− ( 4.354 weeks/month × 5 check-ins/week × 1.4 minutes/check-in
× 1/60 hours/minute × $100 average team member rate/hour )
− ( $5 per user/month × 10 team members )
---------------------------------------------------------------------------- */

export default class CalcSavings extends HTMLElement {
  static get observedAttributes() {
    return ['sharable'];
  }

  get sharable() {
    return this.hasAttribute('sharable');
  }

  calculate() {
    const qty = this.qtyEl.options[this.qtyEl.selectedIndex].value;
    const time = this.timeEl.options[this.timeEl.selectedIndex].value;
    const size = this.sizeEl.options[this.sizeEl.selectedIndex].value;
    const salary = this.salaryEl.options[this.salaryEl.selectedIndex].value;
    const ap = this.apEl.value;

    if (this.sharable) {
      const url = new URL(window.location.href);
      url.searchParams.set('qty', qty);
      url.searchParams.set('time', time);
      url.searchParams.set('size', size);
      url.searchParams.set('salary', salary);
      window.history.replaceState(null, null, url);
    }

    // Assume 4.354 weeks/month, 1.5 minutes to fill out a check-in
    this.savingsMonthly = (
      // Cost of the meetings in team member time
      4.354 * qty * time * (salary / 60) * size
    ) - (
      // Cost of checking in in team member time
      4.354 * qty * 1.5 * (salary / 60) * size
    ) - (
      // Cost of the app
      (ap / 12) * size
    );
    this.monthly = Math.round(this.savingsMonthly);
    this.yearly = this.monthly * 12;
    this.displayMonth.innerHTML = this.monthly.toLocaleString('en-US');
    this.displayYear.innerHTML = this.yearly.toLocaleString('en-US');
  }

  render() {
    this.calculate();
    this.calcFields.forEach((field) => {
      field.addEventListener('change', (e) => {
        this.calculate();
      });
    });
  }

  getParams() {
    // set calculator values from URL parameters
    // test with ?qty=3&size=5&time=10&salary=50
    const urlSearchParams = new URLSearchParams(window.location.search);
    this.params = Object.fromEntries(urlSearchParams.entries());

    Object.entries(this.params).forEach(
      ([key, value]) => {
        this.calcFields.forEach((element) => {
          const currentEl = element;
          if (key === element.getAttribute('data-calc')) {
            currentEl.value = value;
          }
        });
      },
    );
  }

  setParams() {
    // update URL params to reflect calculator value
    const url = new URL(window.location.href);
    Object.entries(this.calcFields).forEach(
      ([key, value]) => url.searchParams.set(key, value),
    );
    window.history.replaceState(null, null, url);
  }

  connectedCallback() {
    this.calcFields = this.querySelectorAll('[data-calc]');
    this.qtyEl = this.querySelector('[data-calc="qty"]');
    this.timeEl = this.querySelector('[data-calc="time"]');
    this.sizeEl = this.querySelector('[data-calc="size"]');
    this.salaryEl = this.querySelector('[data-calc="salary"]');
    this.apEl = this.querySelector('[data-calc="ap"]');

    this.displayMonth = this.querySelector('[data-result="month"]');
    this.displayYear = this.querySelector('[data-result="year"]');
    if (this.sharable) {
      this.getParams();
    }
    this.render();
  }
}

window.customElements.define('calc-savings', CalcSavings);
